const SpacingPropertyDictionary = {
  margin: "m",
  padding: "p",
};

const SpacingSideDictionary = {
  top: "t",
  bottom: "b",
  left: "l",
  right: "r",
  leftRight: "x",
  topBottom: "y",
  all: "",
};

const SpacingDeviceSizeDictionary = {
  extraSmall: "xs",
  small: "sm",
  medium: "md",
  large: "lg",
};

type SpacingProperty = "margin" | "padding";
type SpacingSide = "top" | "bottom" | "left" | "right" | "leftRight" | "topBottom" | "all";
type SpacingSize = 0 | 1 | 2 | 3 | 4 | 5 | "auto";
type SpacingDeviceSize = "extraSmall" | "small" | "medium" | "large";

export const spacing = (
  property: SpacingProperty,
  side: SpacingSide,
  size: SpacingSize,
  deviceSize?: SpacingDeviceSize
): string => {
  const propertyValue = SpacingPropertyDictionary[property];
  const sideValue = SpacingSideDictionary[side];

  if (deviceSize && deviceSize !== "extraSmall") {
    const deviceSizeValue = SpacingDeviceSizeDictionary[deviceSize];
    return `${propertyValue}${sideValue}-${deviceSizeValue}-${size}`;
  }

  return `${propertyValue}${sideValue}-${size}`;
};
